import { Injectable } from '@angular/core';
import { ConfigModuleList } from './configModuleList/config-module-list';
import { ConfigApp } from './configApp/config-app';

@Injectable()
export class AppInitService {

	constructor(
		private configModuleList: ConfigModuleList,
		private configApp: ConfigApp
	) {
	}

	someInit(): void {
		this.configModuleList.init();
		this.configApp.init();
	}

}
